/*
  NordicVend: recensionskarusellens skript (snippets/NV-REVIEW-carousel.liquid).
  Låg tidigare inline i snippeten. Som egen fil cachas den mellan sidvisningar.
  Laddas med defer från snippeten. Värden från Liquid läses från skripttaggens
  data-attribut (document.currentScript), så filen innehåller ingen Liquid.
*/
(function () {
  document.querySelectorAll('.nv-review-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('[data-nv-review-track]');
    if (!track) return;
    var dotsWrap = carousel.querySelector('[data-nv-review-dots]');
    var pauseBtn = carousel.querySelector('[data-nv-review-pause]');
    var cards = track.querySelectorAll('.nv-review-card');
    if (cards.length === 0) return;

    var dots = [];
    var activeIndex = -1;

    if (dotsWrap) {
      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'nv-review-carousel__dot';
        dot.setAttribute('aria-label', 'Gå till recension ' + (i + 1));
        dot.addEventListener('click', function () {
          goTo(i);
          resetAutoplay();
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    // Närmaste kort räknas från mitten av spåret, inte från vänsterkanten.
    // Pricken byter då redan när kortet passerat halvvägs.
    function nearestIndex() {
      var center = track.scrollLeft + (track.clientWidth / 2);
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var cardCenter = cards[i].offsetLeft + (cards[i].offsetWidth / 2);
        var dist = Math.abs(cardCenter - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function setActive(idx) {
      if (idx === activeIndex) return;
      activeIndex = idx;
      for (var i = 0; i < dots.length; i++) {
        var isActive = i === idx;
        dots[i].classList.toggle('is-active', isActive);
        if (isActive) {
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].removeAttribute('aria-current');
        }
      }
    }

    // Vid programmerad scroll markeras målpricken direkt. Under tiden ignoreras
    // mellanlägen från scroll-lyssnaren så att pricken inte hoppar tillbaka.
    var pendingTarget = null;
    var pendingTimer = null;

    function clearPending() {
      pendingTarget = null;
      window.clearTimeout(pendingTimer);
    }

    function goTo(index, instant) {
      var wrapped = ((index % cards.length) + cards.length) % cards.length;
      pendingTarget = wrapped;
      window.clearTimeout(pendingTimer);
      pendingTimer = window.setTimeout(clearPending, 800);
      setActive(wrapped);
      track.scrollTo({
        left: cards[wrapped].offsetLeft,
        behavior: instant ? 'instant' : (window.nvScrollBehavior ? window.nvScrollBehavior() : 'smooth')
      });
    }

    // Uppdatera en gång per ritad bildruta istället för 80 ms efter att
    // scrollandet slutat. Prickarna följer fingret i realtid.
    var rafPending = false;
    track.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = true;
      window.requestAnimationFrame(function () {
        rafPending = false;
        var idx = nearestIndex();
        if (pendingTarget !== null) {
          if (idx !== pendingTarget) return;
          clearPending();
        }
        setActive(idx);
      });
    }, { passive: true });

    // Rör användaren spåret själv tar manuell scroll över direkt.
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, clearPending, { passive: true });
    });

    var AUTOPLAY_MS = 4500;
    var autoplayTimer = null;
    /* Respektera prefers-reduced-motion: starta pausad, användaren kan starta via knappen */
    var isManuallyPaused = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var PAUSE_ICON = '<svg data-nv-pause-icon width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="5" width="4" height="14"/><rect x="14" y="5" width="4" height="14"/></svg>';
    var PLAY_ICON = '<svg data-nv-pause-icon width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M8 5v14l11-7z"/></svg>';

    /* Ingen rotation när karusellen är utanför skärmen eller fliken är dold */
    var onScreen = !('IntersectionObserver' in window);
    var hovering = false;

    function startAutoplay() {
      stopAutoplay();
      if (isManuallyPaused || !onScreen || document.hidden) return;
      autoplayTimer = window.setInterval(function () {
        var current = activeIndex;
        goTo(current + 1, current === cards.length - 1);
      }, AUTOPLAY_MS);
    }
    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function resumeAutoplay() {
      if (!hovering) startAutoplay();
    }
    carousel.addEventListener('mouseenter', function () { hovering = true; stopAutoplay(); });
    carousel.addEventListener('mouseleave', function () { hovering = false; startAutoplay(); });
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);
    carousel.addEventListener('touchstart', stopAutoplay, { passive: true });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        isManuallyPaused = !isManuallyPaused;
        pauseBtn.setAttribute('aria-label', isManuallyPaused ? 'Spela upp recensionerna' : 'Pausa recensionerna');
        pauseBtn.innerHTML = isManuallyPaused ? PLAY_ICON : PAUSE_ICON;
        if (isManuallyPaused) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });
    }

    if (pauseBtn && isManuallyPaused) {
      pauseBtn.setAttribute('aria-label', 'Spela upp recensionerna');
      pauseBtn.innerHTML = PLAY_ICON;
    }
    if (!onScreen) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[entries.length - 1].isIntersecting;
        if (onScreen) resumeAutoplay(); else stopAutoplay();
      }).observe(carousel);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else resumeAutoplay();
    });

    setActive(nearestIndex());
    startAutoplay();
  });
})();
